import { AlertMessage } from './alert-message.class';

export class AlertWarning extends AlertMessage {
  readonly icon: string = 'triangle-exclamation';
  readonly type: string = 'warning';

  constructor(code: string, title: string, message: string) {
    super(code, title, message);
  }
}
